import React from 'react';

const PostCtaAction = () => (
  <span>
    <span className="u-text-small u-co-grey u-hide-on-mobile">
      If you need help or having trouble
      please contact our&nbsp;
      <a
        className="u-co-grey u-td-underline"
        href="mailto:support@getsquire.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        customer support
      </a>.
    </span>
    <span className="u-text-small u-co-grey u-hide-on-desktop">
      If you need help or having trouble<br />
      please contact our&nbsp;
      <a
        className="u-co-grey u-td-underline"
        href="mailto:support@getsquire.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        customer support
      </a>.
    </span>
  </span>
);

export default PostCtaAction;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerAddedToWaitingList/components/PostCtaAction.jsx